import { css, Theme } from '@emotion/react'
import { Container, Box, Typography } from '@mui/material'

import { PostsQuery } from 'generated/graphql.api'
import BlogList from '~/components/organisms/BlogList'
import { categories } from '~/constants/categories'

type Props = {
  data: PostsQuery
  cat?: string
}

const BlogListTemplate: React.FC<Props> = ({ data, cat }) => {
  const name = categories[`${cat}`]?.name || ''

  return (
    <Container component='section' css={styles.container}>
      <Box css={styles.head}>
        {cat ? (
          <Typography
            variant='h2'
            component='h2'
            color='primary'
            css={styles.category}>
            {cat} | {name}
          </Typography>
        ) : null}
        <div css={styles.title}>ブログ一覧</div>
        <div css={styles.subtitle}>Blog</div>
      </Box>
      <BlogList data={data} />
    </Container>
  )
}

const styles = {
  container: css`
    max-width: 1200px;
    margin: 0 auto;
    padding: 100px 0 100px;
    @media (max-width: 1200px) {
      width: 800px;
      padding: 100px auto 100px;
    }
    @media (max-width: 768px) {
      width: 100vw;
      padding: 100px auto 100px;
    }
  `,
  head: css`
    padding: 40px 60px 120px;
    @media (max-width: 768px) {
      padding: 60px;
    }
  `,
  category: css`
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 700;
    font-size: 2rem;
    @media (max-width: 768px) {
      font-size: 1.5rem;
      text-align: center;
    }
  `,
  title: (theme: Theme) => css`
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 700;
    font-size: 4rem;
    color: ${theme.palette.primary.main};
    @media (max-width: 768px) {
      font-size: 2.5rem;
      text-align: center;
    }
  `,
  subtitle: (theme: Theme) => css`
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 700;
    font-size: 1.6rem;
    color: ${theme.palette.primary.main};
    @media (max-width: 768px) {
      text-align: center;
    }
  `,
}

export default BlogListTemplate
